function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { safeInit } from "./includes/utils";
import ProductInformations from "./includes/_product-informations.class";
import NavigationHistory from "./includes/_navigationHistory.class";
import Layer from "@mozaic-ds/freemarker/js/modules/_layer";
import { isElementLowerThanThreshold } from "./includes/elementThreshold.tools";
import InstallmentPayments from "./includes/installment-payments";
import { addToCart, initAddToCart } from "./includes/_atc";
import initOffers from "./includes/_offers";
import initPopin from "./includes/_popin";
import { initChangeStoreLink, initChangeStoreLinkWithStock } from "./includes/_change-store";
import setLayer from "./includes/_layer";
import setCheckedRadio from "./includes/_setCheckedRadio";
import initQuantitySelector from "./includes/_quantity-selector";
import RagProductDetail from "./includes/_rag-productdetail.class";
if (typeof __webpack_public_path__ !== "undefined") {
  __webpack_public_path__ = "/static/js/productdetail/";
}
var ProductDetail = /*#__PURE__*/function (_lm$Composant) {
  function ProductDetail(id) {
    var _this;
    _classCallCheck(this, ProductDetail);
    _this = _callSuper(this, ProductDetail, [id]);
    var productDetailSelector = "#product-detail";
    var component = document.querySelector(productDetailSelector);
    if (!component) {
      return _possibleConstructorReturn(_this);
    }

    // product part

    safeInit("accordion", function () {
      var productInformationElement = component.querySelector("#product-informations");
      if (productInformationElement) {
        var productInformationsInstance = new ProductInformations(productInformationElement);
        productInformationsInstance.initAccordion();
      }
    });
    safeInit("rag-productdetail", function () {
      var mainRag = component.querySelector(".o-ragProductDetail");
      if (mainRag) {
        var rag = new RagProductDetail(component);
        rag.initRag();
      }
    });
    safeInit("carousel", function () {
      var mainCarousel = component.querySelector("#product-carousel");
      if (mainCarousel) {
        import(/* webpackChunkName: "productCarousel" */"./includes/_productCarousel.class").then(function (module) {
          return new module["default"](mainCarousel);
        })["catch"](console.error);
      }
    });
    safeInit("gallery", function () {
      var mainGallery = component.querySelector('#product-gallery');
      if (mainGallery) {
        import(/* webpackChunkName: "productGallery" */"./includes/_productGallery.class").then(function (module) {
          return new module["default"](mainGallery);
        })["catch"](console.error);
      }
    });
    safeInit("media-zoom", function () {
      var mediaZoom = component.querySelector("#media-zoom");
      if (mediaZoom) {
        import(/*webpackChunkName: "mediaZoom" */"./includes/mediaZoom/_mediaZoom.class").then(function (module) {
          return new module["default"](mediaZoom);
        })["catch"](console.error);
      }
    });
    safeInit("video", function () {
      var videos = component.querySelectorAll('.video-js');
      if (videos) {
        import(/* webpackChunkName: "video" */'integration-web-core--socle/js/assets/modules/_video.class').then(function (module) {
          new module["default"]();
        })["catch"](console.error);
      }
    });
    safeInit("layers", function () {
      [{
        'button': '#js-f-gas-legals',
        'layer': 'js-layer-f-gas'
      },
      // F-Gas
      {
        'button': '.js-take-back-layer-button',
        'layer': 'js-take-back-layer'
      },
      // Take Back
      {
        'button': '.js-energy-popin-opener',
        'layer': 'js-energy-popin'
      } // Energy
      ].forEach(function (config) {
        var buttonEl = component.querySelector(config.button);
        if (buttonEl) {
          var layer = new Layer({
            'classContent': config.layer
          });
          buttonEl.addEventListener('click', function () {
            return layer.open();
          });
        }
      });
    });
    safeInit("second-life", function () {
      var secondLife = component.querySelector(".m-secondLife");
      if (secondLife) {
        var refererElement = secondLife.querySelector('.js-content-wrapper');
        var button = secondLife.querySelector('.js-btn-showSecondLifeText');
        var THRESHOLD = 50;
        if (refererElement && !isElementLowerThanThreshold(refererElement, THRESHOLD)) {
          button.classList.remove('kl-hidden');
          button.addEventListener('click', function () {
            refererElement.setAttribute('data-expanded', "".concat((refererElement.getAttribute('data-expanded') !== 'true').toString()));
            button.setAttribute('aria-expanded', "".concat((button.getAttribute('aria-expanded') !== 'true').toString()));
          });
        }
      }
    });
    safeInit("json-ld-product", function () {
      var jsonLds = component.querySelectorAll('.js-json-ld-container script.dataJsonLd');
      if ((jsonLds === null || jsonLds === void 0 ? void 0 : jsonLds.length) > 0) {
        var _iterator = _createForOfIteratorHelper(jsonLds),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var jsonLd = _step.value;
            var jsonLdData = JSON.parse(jsonLd.innerHTML);
            window.MetaTagEventBus.emit('jsonLdTrigger', {
              data: jsonLdData
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    });

    // offer part

    safeInit("main-add-to-cart", function () {
      var form = component.querySelector(".js-add-to-cart-pdp-form");
      if (form) {
        initAddToCart(form);
        form.addEventListener('submit', addToCart.bind(_this, form));
      }
    });
    safeInit("other-add-to-cart", function () {
      var forms = component.querySelectorAll(".js-add-to-cart-form");
      if (forms) {
        initOffers(_this, forms);
      }
    });
    safeInit("change-store", function () {
      var links = component.querySelectorAll(".js-delivery-store-link");
      if (links) {
        initChangeStoreLink(links);
      }
    });
    safeInit("change-store-with-stock", function () {
      var links = component.querySelectorAll(".js-choose-store-stock");
      if (links) {
        initChangeStoreLinkWithStock(links);
      }
    });
    safeInit("quantity-selector", function () {
      var form = component.querySelector(".js-add-to-cart-pdp-form");
      initQuantitySelector(component, form);
    });
    safeInit("ecopart-popin", function () {
      var buttons = component.querySelectorAll(".js-popin-deee__button");
      if (buttons) {
        initPopin(buttons);
      }
    });
    safeInit("second-life-popin", function () {
      var buttons = component.querySelectorAll(".js-popin-refurbished__button");
      if (buttons) {
        initPopin(buttons);
      }
    });
    safeInit("non-recoverable-vat-popin", function () {
      var buttons = component.querySelectorAll(".js-popin-non-recoverable-vat__button");
      if (buttons) {
        initPopin(buttons);
      }
    });
    safeInit("installments", function () {
      var oneyButton = component.querySelector('.js-triggerOney');
      var paypalButton = component.querySelector('.js-triggerPaypal');
      if (oneyButton || paypalButton) {
        var installmentPayments = new InstallmentPayments();
        if (oneyButton) installmentPayments.installment0ney(oneyButton);
        if (paypalButton) installmentPayments.installmentPaypal(paypalButton);
      }
    });
    safeInit("installation-package", function () {
      var offerRadioButtons = component.querySelectorAll("input.js-offer-radio");
      setCheckedRadio(offerRadioButtons, "li.js-offer-radio");
      var reduceVatLayer = component.querySelector(".js-reducedvat-layer-button");
      setLayer(_this, reduceVatLayer, 'js-reducedvat-layer');
      var ctaTva = component.querySelector(".js-reducedvat-layer .js-layer-first-cta");
      if (ctaTva) {
        ctaTva.addEventListener('click', function () {
          var link = ctaTva.dataset.link;
          if (link) {
            window.open(link, '_blank');
          }
        });
      }
    });
    safeInit("delivery-layer", function () {
      var layerDeliveryButton = component.querySelector('.js-delivery-layer-button');
      setLayer(_this, layerDeliveryButton, 'js-layer-all-delivery-mode');
    });
    safeInit("tracking-event", function () {
      var elemToTrack = component.querySelectorAll('.js-event-cdl');
      elemToTrack.forEach(function (elm) {
        elm.addEventListener('click', function (e) {
          var _e$target$dataset = e.target.dataset,
            eventName = _e$target$dataset.eventName,
            eventData = _e$target$dataset.eventData;
          if (eventName && eventData) {
            _this.hitCdlEventTracking(eventName, eventData);
          }
        });
      });
    });
    return _this;
  }
  _inherits(ProductDetail, _lm$Composant);
  return _createClass(ProductDetail, [{
    key: "hitCdlEventTracking",
    value: function hitCdlEventTracking(eventName, eventData) {
      var jsonEvents = JSON.parse(eventData.replaceAll('\'', '"'));
      if (_typeof(tC.event) === 'object') {
        return tC.event.cdl_event(this, {
          'event_name': eventName,
          'event_data': jsonEvents
        });
      }
    }
  }]);
}(lm.Composant);
export { ProductDetail as default };
lm.DOMReady(function () {
  new ProductDetail("productdetail");
  new NavigationHistory();
});